/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const WifiZero = [["path", { d: "M12 20h.01" }]];

export { WifiZero as default };
//# sourceMappingURL=wifi-zero.js.map
